import React, { useContext, useEffect, useState } from "react";
import { AuthContext } from "../../context/authContext";
import SidebarComponent from "../../components/dashboard/Sidebar";
import Loader from "../../components/Loader";
import axios from "axios";
import { BASE_URL } from "../../components/BaseUrl";
import { useParams } from "react-router-dom";
import CircularProgress from "@mui/material/CircularProgress";
import Alert from "@mui/material/Alert";
import Snackbar from "@mui/material/Snackbar";

const SingleCoin = () => {
  const { id } = useParams();
  const { admin } = useContext(AuthContext);
  const [coin, setCoin] = useState(null);
  const [name, setName] = useState("");
  const [symbol, setSymbol] = useState("");
  const [networks, setNetworks] = useState([]);
  const [network, setNetwork] = useState("");
  const [price, setPrice] = useState("");
  const [success, setSuccess] = useState(null);
  const [loading, setLoading] = useState(false);

  async function updateDetails() {
    try {
      setLoading(true);
      const res = await axios.post(`${BASE_URL}/txns/coin/update/${id}`, {
        name,
        symbol,
        networks,
        price,
      });
      if (res.data.status === "success") {
        setSuccess(true);
        setLoading(false);
      }
    } catch (error) {
      console.log(error);
      setSuccess(false);
      setLoading(false);
    }
  }

  const handleKeyDown = (event) => {
    if (event.key === "Tab") {
      event.preventDefault(); // prevent tab from moving focus to next element
      const newNetwork = network.charAt(0).toUpperCase() + network.slice(1);

      setNetworks([...networks, newNetwork]);
      setNetwork("");
    }
  };
  const handleInputChange = (event) => {
    setNetwork(event.target.value);
  };

  if (coin !== null) {
    setNetworks(coin.networks);
  }

  useEffect(() => {
    axios
      .get(`${BASE_URL}/txns/coin/${id}`)
      .then((res) => {
        setCoin(res.data.data);
      })
      .catch((err) => {
        console.log(err);
      });
  }, [id]);

  return (
    <div>
      <div>
        <Loader />
      </div>
      <div>
        <SidebarComponent user={admin} />
      </div>
      <div className="p-4 sm:ml-64 bg-[#0a0c0f] min-h-screen">
        <div className="p-4 border border-gray-600 border-dashed min-h-screen rounded-lg dark:border-gray-700 mt-20">
          {coin && (
            <div>
              <div>
                <h1 className="text-gray-400 text-xl font-medium">Settings</h1>
              </div>
              <form className="md:grid grid-cols-3 gap-10 mt-10">
                <div>
                  <label htmlFor="name" className="text-gray-300 text-sm">
                    Name
                  </label>
                  <input
                    name="name"
                    defaultValue={coin.name}
                    onChange={(e) => setName(e.target.value)}
                    className="bg-[#181b20] w-full py-3 px-5 text-gray-400 mt-2 outline-none rounded-md"
                  />
                </div>
                <div>
                  <label htmlFor="symbol" className="text-gray-300 text-sm">
                    Symbol
                  </label>
                  <input
                    name="symbol"
                    defaultValue={coin.symbol}
                    onChange={(e) => setSymbol(e.target.value)}
                    className="bg-[#181b20] w-full py-3 px-5 text-gray-400 mt-2 outline-none rounded-md"
                  />
                </div>
                <div>
                  <label htmlFor="image" className="text-gray-300 text-sm">
                    Image
                  </label>
                  <input
                    name="image"
                    defaultValue={coin.image}
                    readOnly
                    className="bg-[#181b20] w-full py-3 px-5 text-gray-400 mt-2 outline-none rounded-md"
                  />
                </div>
                <div>
                  <label htmlFor="Networks" className="text-gray-300 text-sm">
                    Networks
                  </label>
                  <input
                    name="Networks"
                    onChange={handleInputChange}
                    onKeyDown={handleKeyDown}
                    className="bg-[#181b20] w-full py-3 px-5 text-gray-400 mt-2 outline-none rounded-md"
                  />
                  <div className="flex items-center space-x-3">
                    {networks &&
                      networks.length > 0 &&
                      networks.map((singleNetwork, index) => {
                        return (
                          <div
                            onClick={() => {
                              networks.splice(index, 1);
                            }}
                            key={index}
                            className="box"
                          >
                            {singleNetwork}
                          </div>
                        );
                      })}
                  </div>
                </div>
                <div>
                  <label htmlFor="price" className="text-gray-300 text-sm">
                    Price
                  </label>
                  <input
                    name="price"
                    defaultValue={coin.price}
                    onChange={(e) => setPrice(e.target.value)}
                    className="bg-[#181b20] w-full py-3 px-5 text-gray-400 mt-2 outline-none rounded-md"
                  />
                </div>
                <div>
                  <button
                    onClick={(e) => {
                      e.preventDefault();
                      updateDetails();
                    }}
                    type="submit"
                    className="md:w-1/2 w-full bg-[#b2ffce] px-5 py-2 rounded-md font-medium"
                  >
                    {loading ? (
                      <CircularProgress color="inherit" size="25px" />
                    ) : (
                      "Submit"
                    )}
                  </button>
                </div>
              </form>
            </div>
          )}
          {success === true && (
            <Snackbar open={true} autoHideDuration={5000}>
              <Alert severity="success">
                Coin has been updated successfully
              </Alert>
            </Snackbar>
          )}
          {success === false && (
            <Snackbar open={true} autoHideDuration={5000}>
              <Alert severity="error">
                An error occured, please try again later
              </Alert>
            </Snackbar>
          )}
        </div>
      </div>
    </div>
  );
};

export default SingleCoin;
